import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_points = z.any()
export type TagsGetCollection_points = z.infer<typeof tagsGetCollection_points>

export const responseGetCollection_points = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "type": z.enum(["electricity","gas","water","coal","heat","other"]), "identifier": z.string(), "customType": z.string().optional(), "customUnit": z.string().optional(), "supplier": z.string(), "price": z.string(), "distributionRate": z.union([z.string(), z.null()]), "breaker": z.union([z.string(), z.null()]), "singleRateTariff": z.boolean().optional(), "buildingId": z.string(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "meterCodes": z.array(z.string()).optional(), "productionEan": z.union([z.string(), z.null()]).optional(), "note": z.union([z.string(), z.null()]).optional(), "order": z.number().optional(), "consumptionReminderEnabled": z.boolean().optional(), "consumptionReminderStartDate": z.union([z.string().date(), z.null()]).optional(), "consumptionReminderFrequency": z.enum(["weekly","monthly","yearly"]).optional(), "consumptionReminderRecipients": z.array(z.string().email().max(255)).optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetCollection_points = z.infer<typeof responseGetCollection_points>

interface IGetCollection_points extends BaseMethodType {
  tags: TagsGetCollection_points,
  response: ResponseGetCollection_points
}
export const URL = '/collection-points'
export const validation = {
  get: {
    tags: tagsGetCollection_points,
    response: responseGetCollection_points
  }
}
export interface Collection_points extends BaseRouteType {
  get: IGetCollection_points
}